import React from 'react';
import TextComponent from 'shared/components/TextComponent';
import Label from 'shared/components/Label';
import Tooltip from 'shared/components/Tooltip';

const HoldDownQuantity = (props) => {
  const { name,
    label,
    required,
    inputId,
    tooltip,
    parameters,
    onChangeParameter,
    children,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.value);

  const value = parameters[name];

  return (
    <div className="row g-0 mb-3">
      <div className="col-4 col-md-3 col-lg-4">
        <img
          src={Spree.image_assets.hold_downs}
          alt="Hold Down Quantity"
          className="img-fluid mb-3" />
      </div>
      <div className="col-8 col-md-9 col-lg-8 ps-3 ps-md-0 ps-lg-3">
        <div className="row g-0">
          <div className="col-7 col-md-12 col-lg-7">
            <Label label={label} required={required} > <Tooltip id={`tooltip-${name}`} title={tooltip} /> </Label>
          </div>
          <div className="col-5 ps-2 ps-md-0 ps-lg-2">
            <TextComponent
              label={null}
              name={name}
              inputId={inputId}
              value={value || ''}
              required={required}
              onChange={onChange}
              tooltip={tooltip}
              min="1"
              wrapClass={false} />
          </div>
        </div>
        <span className="text-muted">We recommend a minimum of two per board</span>
        {children}
      </div>
    </div>
  );
};

HoldDownQuantity.defaultProps = {
  inputId: 'hold_down_quantity',
  label: '# of Hold Downs ($2 each)',
  name: 'hold_down_board_quantity',
  required: true,
};

export default HoldDownQuantity;
